/* =========================================================
   Product Personalizer V2 – Test-Version
   Eigenständige Datei. Beeinflusst product-personalizer.js NICHT.
   Sucht nur nach [data-pp2] und arbeitet ausschließlich
   innerhalb dieses Roots.

   Neu gegenüber V1:
   - Beispiellieder kommen aus der Section (JSON), nicht mehr
     fest aus dem Code.
   - Alle Texte/Fehlermeldungen/Beschriftungen kommen aus der
     Section-Konfiguration (data-pp2-config).
   - Die Zeichenbegrenzung wird aus dem maxlength-Attribut der
     Felder gelesen (im Theme-Editor einstellbar).
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-pp2]');
  if (!root) return;

  // ---- Konfiguration & Daten aus der Section lesen ----
  let CFG = {};
  let SONGS = [];

  try {
    const cfgEl = root.querySelector('[data-pp2-config]');
    if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
  } catch (e) { CFG = {}; }

  try {
    const songsEl = root.querySelector('[data-pp2-songs]');
    if (songsEl) SONGS = JSON.parse(songsEl.textContent);
  } catch (e) { SONGS = []; }

  const txt = (key, fallback) => (CFG[key] != null && CFG[key] !== '' ? CFG[key] : fallback);
  const ERR = CFG.errors || {};
  const PROP = CFG.propertyLabels || {};

  // ---- Beispiellieder nach Gruppe (Tab) sortieren, Reihenfolge erhalten ----
  const DATA = {};
  SONGS.forEach((s) => {
    const g = (s.group && String(s.group).trim()) || 'Beispiele';
    if (!DATA[g]) DATA[g] = [];
    DATA[g].push(s);
  });

  // ---- Elemente ----
  const openBtns = document.querySelectorAll('[data-pp2-open]');
  const modal = root.querySelector('[data-personalizer-modal]');
  const closeBtns = root.querySelectorAll('[data-personalizer-close]');
  const nextBtn = root.querySelector('[data-next-step]');
  const prevBtns = root.querySelectorAll('[data-prev-step]');
  const submitBtn = root.querySelector('[data-submit-personalizer]');
  const steps = root.querySelectorAll('[data-step]');
  const progressItems = root.querySelectorAll('[data-progress-step]');
  const otherStyleWrap = root.querySelector('[data-other-style-wrap]');

  const exampleOpenBtn = root.querySelector('[data-open-example-player]');
  const exampleModal = root.querySelector('[data-example-modal]');
  const exampleCloseBtns = root.querySelectorAll('[data-close-example-player]');
  const stepTitle = root.querySelector('[data-step-title]');
  const errorStep1 = root.querySelector('[data-error-step="1"]');
  const errorStep2 = root.querySelector('[data-error-step="2"]');

  const upsellBox = root.querySelector('[data-pp2-upsell-box]');
  const upsellOffer = root.querySelector('[data-pp2-upsell-offer]');
  const upsellField = root.querySelector('[data-pp2-upsell-field]');
  const upsellUnlockBtn = root.querySelector('[data-pp2-upsell-unlock]');
  const upsellRemoveBtn = root.querySelector('[data-pp2-upsell-remove]');

  const mainVariantId = root.dataset.mainVariantId;
  const cdVariantId = root.dataset.cdVariantId;
  const usbVariantId = root.dataset.usbVariantId;
  const giftWrapVariantId = root.dataset.giftWrapVariantId;
  const giftCardVariantId = root.dataset.giftCardVariantId;
  const rush48VariantId = root.dataset.rush48VariantId;
  const rush24VariantId = root.dataset.rush24VariantId;
  const lyricsPdfVariantId = root.dataset.lyricsPdfVariantId;
  const charUpsellVariantId = root.dataset.charUpsellVariantId;
  const opt4VariantId = root.dataset.opt4VariantId;

  const state = {
    currentStep: 1,
    occasion: '',
    style: '',
    styleOther: '',
    mainPerson: '',
    details: '',
    voice: '',
    pronunciation: '',
    deliveryType: 'download',
    showWrap: false,
    showCard: false,
    giftWrap: 'no',
    giftCard: 'no',
    processingRush: 'none',
    lyricsPdf: 'no',
    charUpsellActive: false
  };

  let popupPlayerInitialized = false;
  let scrollY = 0;
  let bodyWasLocked = false;

  function lockBodyScroll() {
    if (bodyWasLocked) return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    bodyWasLocked = true;
    document.body.classList.add('pp2-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    if (!bodyWasLocked) return;
    bodyWasLocked = false;
    document.body.classList.remove('pp2-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function getCurrentErrorBox() {
    if (state.currentStep === 2) return errorStep2;
    return errorStep1;
  }

  function showError(message) {
    hideError();
    const box = getCurrentErrorBox();
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function hideError() {
    [errorStep1, errorStep2].forEach((box) => {
      if (!box) return;
      box.hidden = true;
      box.textContent = '';
    });
  }

  // ---- Zeichenzähler (liest maxlength aus dem Feld selbst) ----
  function bindCounter(name) {
    const field = root.querySelector(`[data-field="${name}"]`);
    const counter = root.querySelector(`[data-pp2-counter="${name}"]`);
    if (!field || !counter) return;

    const update = () => {
      const max = field.getAttribute('maxlength');
      counter.textContent = max ? `${field.value.length}/${max}` : `${field.value.length}`;
    };

    field.addEventListener('input', () => {
      update();
      hideError();
    });

    update();
  }

  // ---- Zeichen-Erweiterung (3. Strophe) ----
  // Kasten ist unsichtbar und erscheint erst, wenn die Schwelle (z. B. 950)
  // im Detailfeld erreicht ist – oder wenn die Erweiterung bereits aktiv ist.
  function updateUpsellHighlight() {
    if (!upsellBox) return;
    if (state.charUpsellActive) {
      upsellBox.hidden = false;
      upsellBox.classList.remove('is-highlight');
      return;
    }
    const detailsField = root.querySelector('[data-field="details"]');
    const threshold = parseInt(CFG.charUpsellThreshold, 10) || 950;
    const len = detailsField ? detailsField.value.length : 0;
    const reached = len >= threshold;
    upsellBox.hidden = !reached;
    upsellBox.classList.toggle('is-highlight', reached);
  }

  function unlockUpsell() {
    state.charUpsellActive = true;
    if (upsellBox) { upsellBox.hidden = false; upsellBox.classList.remove('is-highlight'); }
    if (upsellOffer) upsellOffer.hidden = true;
    if (upsellField) upsellField.hidden = false;
    const bonus = root.querySelector('[data-field="bonusDetails"]');
    if (bonus) bonus.focus();
  }

  function removeUpsell() {
    state.charUpsellActive = false;
    if (upsellField) upsellField.hidden = true;
    if (upsellOffer) upsellOffer.hidden = false;
    updateUpsellHighlight();
  }

  function updateStepTitle(stepNumber) {
    if (!stepTitle) return;
    const titles = CFG.stepTitles || {};
    if (stepNumber === 1) stepTitle.textContent = titles['1'] || 'Song Personalisierung';
    if (stepNumber === 2) stepTitle.textContent = titles['2'] || 'Zubehör';
    if (stepNumber === 3) stepTitle.textContent = titles['3'] || 'Fertig';
  }

  function showStep(stepNumber) {
    steps.forEach((step) => {
      step.hidden = Number(step.dataset.step) !== stepNumber;
    });

    progressItems.forEach((item) => {
      const isActive = Number(item.dataset.progressStep) === stepNumber;
      item.classList.toggle('is-active', isActive);
    });

    state.currentStep = stepNumber;
    updateStepTitle(stepNumber);
    hideError();

    const dialog = root.querySelector('.product-personalizer__dialog');
    if (dialog) dialog.scrollTop = 0;
  }

  function openModal() {
    lockBodyScroll();
    modal.hidden = false;
    showStep(1);
  }

  function closeModal() {
    closeExampleModal();
    modal.hidden = true;
    unlockBodyScroll();
  }

  function initExamplePlayer() {
    if (popupPlayerInitialized) return;
    if (!exampleModal) return;

    const playerRoot = exampleModal.querySelector('[data-xp-player]');
    if (!playerRoot) return;

    popupPlayerInitialized = true;

    const PLACEHOLDER =
      "data:image/svg+xml;charset=utf-8," +
      encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='300' height='300'>
        <defs><linearGradient id='g' x1='0' x2='1'><stop offset='0' stop-color='#efe6dc'/><stop offset='1' stop-color='#e5dbd0'/></linearGradient></defs>
        <rect width='100%' height='100%' rx='36' ry='36' fill='url(#g)'/>
        <text x='50%' y='52%' dominant-baseline='middle' text-anchor='middle' fill='#7a6f66' font-family='Arial' font-size='20'>Cover</text>
      </svg>`);

    const audio = playerRoot.querySelector('[data-xp-audio]');
    const coverEl = playerRoot.querySelector('[data-xp-cover]');
    const titleEl = playerRoot.querySelector('[data-xp-title]');
    const artistEl = playerRoot.querySelector('[data-xp-artist]');
    const listEl = playerRoot.querySelector('[data-xp-list]');
    const tabsEl = playerRoot.querySelector('[data-xp-tabs]');
    const countEl = playerRoot.querySelector('[data-xp-count]');

    const btnPrev = playerRoot.querySelector('[data-xp-prev]');
    const btnPlay = playerRoot.querySelector('[data-xp-play]');
    const btnNext = playerRoot.querySelector('[data-xp-next]');
    const btnRep = playerRoot.querySelector('[data-xp-repeat]');
    const playIcon = playerRoot.querySelector('[data-xp-play-icon]');

    const seek = playerRoot.querySelector('[data-xp-seek]');
    const curEl = playerRoot.querySelector('[data-xp-cur]');
    const durEl = playerRoot.querySelector('[data-xp-dur]');
    const volEl = playerRoot.querySelector('[data-xp-vol]');

    let style = null;
    let idx = -1;
    let loadedUrl = null;
    let seeking = false;
    let repeat = false;

    function tracks() {
      return style ? (DATA[style] || []) : [];
    }

    function current() {
      return idx >= 0 ? tracks()[idx] : null;
    }

    function fmt(sec) {
      if (!isFinite(sec)) return '0:00';
      sec = Math.max(0, Math.floor(sec));
      const m = Math.floor(sec / 60);
      const s = sec % 60;
      return `${m}:${String(s).padStart(2, '0')}`;
    }

    function setCover(src, alt) {
      coverEl.src = src || PLACEHOLDER;
      coverEl.alt = alt || 'Cover';
      coverEl.onerror = () => {
        coverEl.src = PLACEHOLDER;
        coverEl.onerror = null;
      };
    }

    function setPlayIcon(isPlaying) {
      playIcon.innerHTML = isPlaying
        ? '<path d="M6 5h4v14H6V5zm8 0h4v14h-4V5z"></path>'
        : '<path d="M8 5v14l11-7z"></path>';
    }

    function markCurrent() {
      [...listEl.querySelectorAll('.xp-track')].forEach((row, i) => {
        row.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    function unload() {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      loadedUrl = null;
      seek.value = 0;
      curEl.textContent = '0:00';
      durEl.textContent = '0:00';
      setPlayIcon(false);
    }

    function ensureLoaded() {
      const t = current();
      if (!t) return false;
      if (loadedUrl !== t.url) {
        audio.src = t.url;
        loadedUrl = t.url;
      }
      return true;
    }

    async function play() {
      if (!ensureLoaded()) return;
      try {
        await audio.play();
        setPlayIcon(true);
      } catch (e) {}
    }

    function pause() {
      audio.pause();
      setPlayIcon(false);
    }

    function setNow(t) {
      if (!t) {
        titleEl.textContent = '—';
        artistEl.textContent = style ? `Stil: ${style}` : (txt('examplePickStyle', 'Wähle einen Stil'));
        setCover(PLACEHOLDER, 'Cover');
        return;
      }
      titleEl.textContent = t.title || '—';
      artistEl.textContent = t.artist || (style || '');
      setCover(t.cover, t.title ? `Cover: ${t.title}` : 'Cover');
    }

    function selectTrack(newIdx, autoplay) {
      const list = tracks();
      if (!list.length) return;
      idx = Math.max(0, Math.min(newIdx, list.length - 1));
      setNow(current());
      markCurrent();
      unload();
      if (autoplay) play();
    }

    btnPlay.addEventListener('click', () => {
      if (!current()) {
        const list = tracks();
        if (!list.length) return;
        idx = 0;
        setNow(current());
        markCurrent();
      }
      if (audio.paused) play();
      else pause();
    });

    btnPrev.addEventListener('click', () => {
      if (idx <= 0) selectTrack(0, true);
      else selectTrack(idx - 1, true);
    });

    btnNext.addEventListener('click', () => {
      const list = tracks();
      if (!list.length) return;
      if (idx < list.length - 1) selectTrack(idx + 1, true);
      else selectTrack(list.length - 1, true);
    });

    btnRep.addEventListener('click', () => {
      repeat = !repeat;
      btnRep.classList.toggle('xp-repeat-on', repeat);
    });

    if (volEl) {
      audio.volume = parseFloat(volEl.value || '0.9');
      volEl.addEventListener('input', () => {
        audio.volume = parseFloat(volEl.value || '0.9');
      });
    }

    seek.addEventListener('input', () => {
      seeking = true;
      const d = audio.duration || 0;
      if (d > 0) {
        const v = parseFloat(seek.value) / 1000;
        curEl.textContent = fmt(v * d);
      }
    });

    seek.addEventListener('change', () => {
      const d = audio.duration || 0;
      if (d > 0) {
        const v = parseFloat(seek.value) / 1000;
        audio.currentTime = v * d;
      }
      seeking = false;
    });

    audio.addEventListener('timeupdate', () => {
      if (seeking) return;
      const d = audio.duration || 0;
      const t = audio.currentTime || 0;
      curEl.textContent = fmt(t);
      durEl.textContent = fmt(d);
      if (d > 0) seek.value = String(Math.round((t / d) * 1000));
    });

    audio.addEventListener('loadedmetadata', () => {
      durEl.textContent = fmt(audio.duration);
    });

    audio.addEventListener('play', () => setPlayIcon(true));
    audio.addEventListener('pause', () => setPlayIcon(false));

    audio.addEventListener('ended', () => {
      const list = tracks();
      if (repeat) {
        audio.currentTime = 0;
        audio.play().catch(() => {});
        return;
      }
      if (idx < list.length - 1) {
        selectTrack(idx + 1, true);
      } else {
        unload();
      }
    });

    const imgObserver = ('IntersectionObserver' in window)
      ? new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const img = entry.target;
            const real = img.dataset.src;
            if (real) {
              img.src = real;
              delete img.dataset.src;
            }
            obs.unobserve(img);
          });
        }, { rootMargin: '300px' })
      : null;

    function renderTabs() {
      const styles = Object.keys(DATA);
      tabsEl.innerHTML = '';

      if (!styles.length) {
        countEl.textContent = txt('exampleNone', 'Keine Beispiele');
        setNow(null);
        return;
      }

      styles.forEach((name, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'xp-tab';
        b.textContent = name;
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

        b.addEventListener('click', () => {
          tabsEl.querySelectorAll('.xp-tab').forEach((x) => x.setAttribute('aria-selected', 'false'));
          b.setAttribute('aria-selected', 'true');
          style = name;
          idx = -1;
          setNow(null);
          unload();
          renderList();
        });

        tabsEl.appendChild(b);
      });

      style = styles[0];
      renderList();
    }

    function renderList() {
      const list = tracks();
      listEl.innerHTML = '';
      countEl.textContent = list.length
        ? `${list.length} ${txt('exampleCountSuffix', 'Beispiele')}`
        : txt('exampleNone', 'Keine Beispiele');

      list.forEach((t, i) => {
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'xp-track';
        row.addEventListener('click', () => selectTrack(i, true));

        const img = document.createElement('img');
        img.className = 'xp-tcover';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = PLACEHOLDER;
        img.dataset.src = t.cover || PLACEHOLDER;
        img.alt = t.title ? `Cover: ${t.title}` : 'Cover';
        img.onerror = () => {
          img.src = PLACEHOLDER;
          img.onerror = null;
        };

        if (imgObserver) imgObserver.observe(img);
        else img.src = img.dataset.src;

        const txtWrap = document.createElement('div');

        const name = document.createElement('div');
        name.className = 'xp-tname';
        name.textContent = t.title || `Track ${i + 1}`;

        const meta = document.createElement('div');
        meta.className = 'xp-tmeta';
        meta.textContent = t.artist || style || '';

        txtWrap.appendChild(name);
        txtWrap.appendChild(meta);

        row.appendChild(img);
        row.appendChild(txtWrap);
        listEl.appendChild(row);
      });

      if (list.length) {
        idx = 0;
        setNow(list[0]);
        markCurrent();
        unload();
      } else {
        idx = -1;
        setNow(null);
        unload();
      }

      btnRep.classList.toggle('xp-repeat-on', repeat);
    }

    setCover(PLACEHOLDER, 'Cover');
    setPlayIcon(false);
    renderTabs();
  }

  function openExampleModal() {
    if (!exampleModal) return;
    exampleModal.hidden = false;
    const innerDialog = exampleModal.querySelector('.product-personalizer__inner-dialog');
    if (innerDialog) innerDialog.scrollTop = 0;
    initExamplePlayer();
  }

  function closeExampleModal() {
    if (!exampleModal) return;
    const audio = exampleModal.querySelector('[data-xp-audio]');
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
    exampleModal.hidden = true;
  }

  function updateCardStates() {
    root.querySelectorAll('[data-card]').forEach((card) => {
      const input = card.querySelector('input[type="radio"]');
      if (!input) return;
      card.classList.toggle('is-selected', input.checked);
      const button = card.querySelector('.product-personalizer__select-button');
      if (button) {
        button.textContent = input.checked
          ? txt('cardSelected', 'Ausgewählt')
          : txt('cardSelect', 'Auswählen');
      }
    });
  }

  function updateOtherStyleVisibility() {
    const styleInput = root.querySelector('[data-field="style"]');
    const trigger = txt('styleOtherTrigger', 'Andere Musikrichtung');
    const show = styleInput && styleInput.value === trigger;
    if (otherStyleWrap) otherStyleWrap.hidden = !show;
  }

  function updateWeddingDateVisibility() {
    const wrap = root.querySelector('[data-pp2-wedding-date-wrap]');
    if (!wrap) return;
    const choice = root.querySelector('[data-field="weddingDateChoice"]:checked');
    wrap.hidden = !(choice && choice.value === 'yes');
  }

  function resetRadioToNo(name) {
    const noInput = root.querySelector(`[data-field="${name}"][value="no"]`);
    if (noInput) noInput.checked = true;
  }

  function updateUpsellVisibility() {
    const deliveryInput = root.querySelector('[data-field="deliveryType"]:checked');
    const showWrap = deliveryInput && deliveryInput.dataset.pp2Giftwrap === 'true';
    const showCard = deliveryInput && deliveryInput.dataset.pp2Giftcard === 'true';

    const wrapBlock = root.querySelector('[data-pp2-upsell="giftwrap"]');
    const cardBlock = root.querySelector('[data-pp2-upsell="giftcard"]');

    if (wrapBlock) {
      wrapBlock.hidden = !showWrap;
      if (!showWrap) resetRadioToNo('giftWrap');
    }
    if (cardBlock) {
      cardBlock.hidden = !showCard;
      if (!showCard) resetRadioToNo('giftCard');
    }

    // Termin-/Variantenauswahl nur bei passender Lieferart zeigen
    const deliveryValue = deliveryInput ? deliveryInput.value : '';
    root.querySelectorAll('[data-pp2-variant-wrap]').forEach((wrap) => {
      wrap.hidden = wrap.dataset.pp2VariantWrap !== deliveryValue;
    });

    positionVariantWraps();
    updateCardStates();
  }

  // Am Handy die Termin-Auswahl direkt unter die gewählte Kachel schieben.
  // Auf dem Desktop bleibt sie an ihrer ursprünglichen Stelle unter der Kachelreihe.
  function positionVariantWraps() {
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    const deliveryInput = root.querySelector('[data-field="deliveryType"]:checked');
    const selectedValue = deliveryInput ? deliveryInput.value : '';

    root.querySelectorAll('[data-pp2-variant-wrap]').forEach((wrap) => {
      const marker = wrap._pp2HomeMarker;
      const key = wrap.dataset.pp2VariantWrap;

      if (isMobile && key === selectedValue && deliveryInput) {
        const card = deliveryInput.closest('[data-card]');
        if (card && card.nextSibling !== wrap) {
          card.parentNode.insertBefore(wrap, card.nextSibling);
        }
      } else if (marker && wrap.previousSibling !== marker) {
        // zurück an die ursprüngliche Position (direkt nach dem Marker)
        marker.parentNode.insertBefore(wrap, marker.nextSibling);
      }
    });
  }

  function getActiveVariantSelect() {
    const deliveryInput = root.querySelector('[data-field="deliveryType"]:checked');
    const deliveryValue = deliveryInput ? deliveryInput.value : '';
    return root.querySelector(`[data-pp2-variant-select="${deliveryValue}"]`);
  }

  function validateRelease() {
    const sel = getActiveVariantSelect();
    if (sel && !sel.value) {
      showError(ERR.variant || 'Bitte wähle einen Termin aus.');
      return false;
    }
    return true;
  }

  function addCalendarDays(startDate, days) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + days);
    return date;
  }

  function formatGermanDate(date) {
    const locale = txt('dateLocale', 'de-DE');
    return new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  function formatGermanTime(date) {
    const locale = txt('dateLocale', 'de-DE');
    return new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }

  function renderDeliveryDates() {
    const prefix = txt('deliveryPrefix', 'Du erhältst dein Lied bis:');
    const timeSuffix = txt('timeSuffix', ' Uhr');
    const standardDays = parseInt(CFG.standardDays, 10) || 3;

    root.querySelectorAll('[data-delivery-kind]').forEach((node) => {
      const kind = node.dataset.deliveryKind;
      const now = new Date();
      let line2 = '';

      if (kind === 'standard') {
        line2 = formatGermanDate(addCalendarDays(now, standardDays));
      }
      if (kind === 'h48') {
        const date = new Date(now.getTime() + 48 * 60 * 60 * 1000);
        line2 = `${formatGermanDate(date)}, ${formatGermanTime(date)}${timeSuffix}`;
      }
      if (kind === 'h24') {
        const date = new Date(now.getTime() + 24 * 60 * 60 * 1000);
        line2 = `${formatGermanDate(date)}, ${formatGermanTime(date)}${timeSuffix}`;
      }

      node.textContent = `${prefix}\n${line2}`;
    });
  }

  function collectStep1() {
    state.occasion = root.querySelector('[data-field="occasion"]')?.value || '';
    state.style = root.querySelector('[data-field="style"]')?.value || '';
    state.styleOther = root.querySelector('[data-field="styleOther"]')?.value.trim() || '';
    state.mainPerson = root.querySelector('[data-field="mainPerson"]')?.value.trim() || '';
    state.details = root.querySelector('[data-field="details"]')?.value.trim() || '';
    state.voice = root.querySelector('[data-field="voice"]')?.value || '';
    state.pronunciation = root.querySelector('[data-field="pronunciation"]')?.value.trim() || '';

    const trigger = txt('styleOtherTrigger', 'Andere Musikrichtung');

    if (!state.occasion) { showError(ERR.occasion || 'Bitte wähle einen Anlass aus.'); return false; }
    if (!state.style) { showError(ERR.style || 'Bitte wähle eine Musikrichtung aus.'); return false; }
    if (state.style === trigger && !state.styleOther) { showError(ERR.styleOther || 'Bitte gib die andere Musikrichtung an.'); return false; }
    if (!state.mainPerson) { showError(ERR.mainPerson || 'Bitte trage die Hauptperson des Liedes ein.'); return false; }
    if (!state.details) { showError(ERR.details || 'Bitte gib Details für den Song an.'); return false; }
    if (!state.voice) { showError(ERR.voice || 'Bitte wähle eine Stimme aus.'); return false; }

    // Hochzeitsdatum: Pflicht, wenn "Ja" gewählt und Feld vorhanden
    const weddingDateField = root.querySelector('[data-field="weddingDate"]');
    const weddingChoice = root.querySelector('[data-field="weddingDateChoice"]:checked');
    if (weddingDateField && weddingChoice && weddingChoice.value === 'yes' && !weddingDateField.value) {
      showError(ERR.weddingDate || 'Bitte wähle das Hochzeitsdatum aus.');
      return false;
    }

    return true;
  }

  function collectStep2() {
    const delRadio = root.querySelector('[data-field="deliveryType"]:checked');
    state.deliveryType = delRadio?.value || 'download';
    state.showWrap = delRadio?.dataset.pp2Giftwrap === 'true';
    state.showCard = delRadio?.dataset.pp2Giftcard === 'true';

    state.giftWrap = root.querySelector('[data-field="giftWrap"]:checked')?.value || 'no';
    state.giftCard = root.querySelector('[data-field="giftCard"]:checked')?.value || 'no';
    state.processingRush = root.querySelector('[data-field="processingTime"]:checked')?.dataset.pp2Rush || 'none';
    state.lyricsPdf = root.querySelector('[data-field="lyricsPdf"]:checked')?.value || 'no';

    // Gewählte Termin-/Produktvariante (z. B. Spotify-Veröffentlichungswoche)
    const sel = getActiveVariantSelect();
    if (sel && sel.value) {
      const opt = sel.options[sel.selectedIndex];
      state.chosenVariantId = sel.value;
      state.chosenVariantLabel = (opt && opt.dataset.pp2Title) || (opt ? opt.text : '');
    } else {
      state.chosenVariantId = '';
      state.chosenVariantLabel = '';
    }
  }

  function buildMainProductProperties(bundleId) {
    const trigger = txt('styleOtherTrigger', 'Andere Musikrichtung');
    const styleValue = state.style === trigger ? `${state.style} - ${state.styleOther}` : state.style;

    const props = {};
    props[PROP.occasion || 'Anlass'] = state.occasion;
    props[PROP.style || 'Musikrichtung'] = styleValue;
    props[PROP.mainPerson || 'Hauptperson'] = state.mainPerson;
    props[PROP.details || 'Song-Details'] = state.details;
    props[PROP.voice || 'Stimme'] = state.voice;
    props[PROP.pronunciation || 'Aussprache / Wünsche'] = state.pronunciation;

    // Hochzeitslied-Felder (nur wenn vorhanden/ausgefüllt)
    const recipientField = root.querySelector('[data-field="recipient"]');
    if (recipientField && recipientField.value.trim()) {
      props[PROP.recipient || 'Gerichtet an'] = recipientField.value.trim();
    }
    const weddingDateField = root.querySelector('[data-field="weddingDate"]');
    const weddingChoice = root.querySelector('[data-field="weddingDateChoice"]:checked');
    if (weddingDateField && weddingChoice && weddingChoice.value === 'yes' && weddingDateField.value) {
      const parts = weddingDateField.value.split('-'); // YYYY-MM-DD
      const nice = parts.length === 3 ? `${parts[2]}.${parts[1]}.${parts[0]}` : weddingDateField.value;
      props[PROP.weddingDate || 'Hochzeitsdatum'] = nice;
    }

    if (state.charUpsellActive) {
      const bonusField = root.querySelector('[data-field="bonusDetails"]');
      const bonusText = bonusField ? bonusField.value.trim() : '';
      if (bonusText) props[PROP.bonus || '3. Strophe'] = bonusText;
    }
    props['_bundle_id'] = bundleId;
    props['_bundle_role'] = 'main';
    props['_bundle_order'] = '1';
    return props;
  }

  function buildChildProperties(bundleId, order) {
    return {
      '_bundle_id': bundleId,
      '_bundle_role': 'child',
      '_bundle_order': String(order)
    };
  }

  async function addItemsToCartAndGoToCart() {
    if (!mainVariantId) {
      showError(ERR.noVariant || 'Keine Hauptvariante gefunden.');
      return;
    }

    const bundleId = `pp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    let bundleOrder = 2;

    const items = [
      {
        id: Number(mainVariantId),
        quantity: 1,
        properties: buildMainProductProperties(bundleId)
      }
    ];

    if (state.deliveryType === 'cd') {
      const id = (getActiveVariantSelect() && state.chosenVariantId) ? state.chosenVariantId : cdVariantId;
      if (id) items.push({ id: Number(id), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.deliveryType === 'usb') {
      const id = (getActiveVariantSelect() && state.chosenVariantId) ? state.chosenVariantId : usbVariantId;
      if (id) items.push({ id: Number(id), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.deliveryType === 'opt4' && opt4VariantId) {
      items.push({ id: Number(opt4VariantId), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.showWrap && state.giftWrap === 'yes' && giftWrapVariantId) {
      items.push({ id: Number(giftWrapVariantId), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.showCard && state.giftCard === 'yes' && giftCardVariantId) {
      items.push({ id: Number(giftCardVariantId), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.processingRush === 'h48' && rush48VariantId) {
      items.push({ id: Number(rush48VariantId), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.processingRush === 'h24' && rush24VariantId) {
      items.push({ id: Number(rush24VariantId), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.lyricsPdf === 'yes' && lyricsPdfVariantId) {
      items.push({ id: Number(lyricsPdfVariantId), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (state.charUpsellActive && charUpsellVariantId) {
      items.push({ id: Number(charUpsellVariantId), quantity: 1, properties: buildChildProperties(bundleId, bundleOrder++) });
    }

    if (submitBtn) submitBtn.disabled = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        let message = ERR.cart || 'Fehler beim Hinzufügen zum Warenkorb.';
        try {
          const errorData = await response.json();
          if (errorData.description) message = errorData.description;
        } catch (e) {}
        throw new Error(message);
      }

      progressItems.forEach((item) => item.classList.remove('is-active'));
      root.querySelector('[data-progress-step="3"]')?.classList.add('is-active');
      updateStepTitle(3);

      window.location.href = '/cart';
    } catch (error) {
      showError(error.message || ERR.unknown || 'Unbekannter Fehler.');
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  // ---- Events ----
  openBtns.forEach((btn) => btn.addEventListener('click', openModal));
  closeBtns.forEach((btn) => btn.addEventListener('click', closeModal));
  prevBtns.forEach((btn) => btn.addEventListener('click', () => showStep(1)));
  exampleOpenBtn?.addEventListener('click', openExampleModal);
  exampleCloseBtns.forEach((btn) => btn.addEventListener('click', closeExampleModal));

  upsellUnlockBtn?.addEventListener('click', unlockUpsell);
  upsellRemoveBtn?.addEventListener('click', removeUpsell);

  root.querySelector('[data-field="details"]')?.addEventListener('input', updateUpsellHighlight);

  nextBtn?.addEventListener('click', () => {
    if (!collectStep1()) return;
    showStep(2);
  });

  submitBtn?.addEventListener('click', async () => {
    collectStep2();
    if (!validateRelease()) return;
    await addItemsToCartAndGoToCart();
  });

  root.querySelectorAll('select, input[type="radio"]').forEach((field) => {
    field.addEventListener('change', () => {
      updateCardStates();
      updateOtherStyleVisibility();
      updateWeddingDateVisibility();
      updateUpsellVisibility();
      hideError();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (exampleModal && !exampleModal.hidden) { closeExampleModal(); return; }
    if (modal && !modal.hidden) { closeModal(); }
  });

  // Ursprungsposition der Termin-Auswahl merken (für die Rückkehr auf Desktop)
  root.querySelectorAll('[data-pp2-variant-wrap]').forEach((wrap) => {
    const marker = document.createComment('pp2-variant-home');
    wrap.parentNode.insertBefore(marker, wrap);
    wrap._pp2HomeMarker = marker;
  });

  let pp2ResizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(pp2ResizeTimer);
    pp2ResizeTimer = setTimeout(positionVariantWraps, 150);
  });

  // ---- Init ----
  bindCounter('details');
  bindCounter('pronunciation');
  bindCounter('bonusDetails');
  renderDeliveryDates();
  updateCardStates();
  updateOtherStyleVisibility();
  updateWeddingDateVisibility();
  updateUpsellVisibility();
  updateUpsellHighlight();
  updateStepTitle(1);
});